<template>
  <div>
    <v-layout row justify-center align-center>
      <table>
        <thead>
          <tr>
            <th class="payment-cells">{{ $t('extracurriculares.pay_reserve.student') }}</th>
            <th class="payment-cells">{{ $t('extracurriculares.pay_reserve.course') }}</th>
            <th class="payment-cells">{{ $t('extracurriculares.pay_reserve.price') }}</th>
            <th class="payment-cells">{{ $t('extracurriculares.pay_reserve.qty') }}</th>
            <th class="payment-cells">{{ $t('extracurriculares.pay_reserve.total') }}</th>
            <th class="payment-cells"></th>
            <th class="payment-cells"></th>
            <th class="payment-cells"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(paymentCourse, pc) in paymentDataCourse" :key="`${pc}-${paymentCourse && paymentCourse.platform_payments_id}-${paymentCourse && paymentCourse.payment_state}`">
            <td align="center">{{paymentCourse.student.full_name}}</td>
            <td v-if="locale == 'es'" align="center">{{paymentCourse.course_name}}</td>
            <td v-else align="center">{{paymentCourse.eng_name}}</td>
            <td align="center">${{formatNumber(paymentCourse.course.discountprice)}}</td>
            <td align="center">{{paymentCourse.qty}}</td>
            <td align="center">${{formatNumber(paymentCourse.course.discountprice * paymentCourse.qty)}}</td>
            <td>
              <v-btn block outline color="info" @click="registerDetails('course', paymentCourse.course_id, paymentCourse.student.id)">{{ $t('extracurriculares.pay_reserve.details') }}</v-btn>
            </td>
            <td>
              <v-btn block color="info" @click="openClothesDetail(paymentCourse.student.id)">{{ $t('extracurriculares.pay_reserve.clothes') }}</v-btn>
            </td>
            <td colspan="2" v-if="paymentCourse.course.provider_payment == 1">
              <v-btn block color="primary">{{ $t('extracurriculares.register.available_courses.provider_pay') }}</v-btn>
            </td>
            <td v-if="paymentCourse.course.discountprice > 0 && paymentCourse.course.provider_payment != 1 && paymentAvailable(paymentCourse.payment_state) && paymentCourse.student.family.employee == 1">
              <v-btn
                v-if="1 == 2"
                @click="payrollPay('course', paymentCourse.enrollment_courses_id, paymentCourse.course.discountprice, paymentCourse.type_id, paymentCourse.student.id)"
                block
                color="primary">{{ $t('extracurriculares.pay_reserve.payroll_discount') }}</v-btn>
            </td>
            <td v-if="paymentCourse.course.discountprice > 0 && paymentCourse.course.provider_payment != 1">

              <div v-if="paymentPending(paymentCourse.payment_state)">
                <v-btn block color="info">{{ $t('extracurriculares.pay_reserve.payment_pending') }}</v-btn>
              </div>
              <div v-if="paymentApproved(paymentCourse.payment_state)">
                <v-btn block color="success">{{ $t('extracurriculares.pay_reserve.payment_approved') }}</v-btn>
              </div>
            </td>
            <td v-if="paymentCourse.course.discountprice > 0 && paymentCourse.course.provider_payment != 1">
              <div v-if="paymentAvailable(paymentCourse.payment_state)">
                <v-btn block
                  :disabled="loading_button !== 0"
                  :loading="loading_button === `${paymentCourse.enrollment_courses_id}-${paymentCourse.student.id}`"
                  @click="tcPay('course', paymentCourse.enrollment_courses_id, paymentCourse.course.discountprice, paymentCourse.type_id, paymentCourse.student.id)"
                  color="primary">{{ $t('extracurriculares.pay_reserve.cc_payment') }}</v-btn>
              </div>
              <div v-if="paymentPending(paymentCourse.payment_state)">
                <v-btn
                  :loading="payment_loading === paymentCourse.platform_payments_id"
                  :disabled="payment_loading === paymentCourse.platform_payments_id"
                  block
                  @click="verifyPay(paymentCourse.platform_payments_id)"
                  color="accent">{{ $t('extracurriculares.pay_reserve.verify') }}</v-btn>
              </div>
              <div v-if="paymentApproved(paymentCourse.payment_state)">
                <v-btn block @click="paymentProof(paymentCourse.platform_payments_id, paymentCourse.course_name)" color="accent">{{ $t('extracurriculares.pay_reserve.see_payment_proof') }}</v-btn>
              </div>
            </td>
            <td>
              <div v-if="paymentFailed(paymentCourse.payment_state)">
                <v-btn block @click="paymentProof(paymentCourse.platform_payments_id, paymentCourse.course_name)" color="error">{{ $t('extracurriculares.pay_reserve.payment_failed') }}</v-btn>
              </div>
            </td>

          </tr>
          <tr v-for="(paymentCourse_ext, pc) in paymentDataCourse_ext" :key="`${pc}E-${paymentCourse_ext && paymentCourse_ext.platform_payments_id}-${paymentCourse_ext && paymentCourse_ext.payment_state}`">
            <td align="center">{{paymentCourse_ext.student_ext.full_name}}</td>
            <td v-if="locale == 'es'" align="center">{{paymentCourse_ext.course_name}}</td>
            <td v-else align="center">{{paymentCourse_ext.eng_name}}</td>
            <td align="center">${{formatNumber(paymentCourse_ext.course.discountprice)}}</td>
            <td align="center">{{paymentCourse_ext.qty}}</td>
            <td align="center">${{formatNumber(paymentCourse_ext.course.discountprice * paymentCourse_ext.qty)}}</td>
            <td>
              <v-btn block outline color="info" @click="registerDetails('course', paymentCourse_ext.course_id, paymentCourse_ext.student_ext.id, true)">{{ $t('extracurriculares.pay_reserve.details') }}</v-btn>
            </td>
            <td>
              <v-btn block color="info" @click="openClothesDetail(paymentCourse_ext.student_ext.id, true)">{{ $t('extracurriculares.pay_reserve.clothes') }}</v-btn>
            </td>
            <td colspan="2" v-if="paymentCourse_ext.course.provider_payment == 1">
              <v-btn block color="primary">{{ $t('extracurriculares.register.available_courses.provider_pay') }}</v-btn>
            </td>
            <td v-if="paymentCourse_ext.course.discountprice > 0 && paymentCourse_ext.course.provider_payment != 1 && paymentAvailable(paymentCourse_ext.payment_state) && paymentCourse_ext.family && paymentCourse_ext.family.employee == 1">
              <v-btn
                v-if="1 == 2"
                @click="payrollPay('course', paymentCourse_ext.enrollment_courses_id, paymentCourse_ext.course.discountprice, paymentCourse_ext.type_id, paymentCourse_ext.student_ext.id, true)"
                block
                color="primary">{{ $t('extracurriculares.pay_reserve.payroll_discount') }}</v-btn>
            </td>
            <td v-if="paymentCourse_ext.course.discountprice > 0 && paymentCourse_ext.course.provider_payment != 1">

              <div v-if="paymentPending(paymentCourse_ext.payment_state)">
                <v-btn block color="info">{{ $t('extracurriculares.pay_reserve.payment_pending') }}</v-btn>
              </div>
              <div v-if="paymentApproved(paymentCourse_ext.payment_state)">
                <v-btn block color="success">{{ $t('extracurriculares.pay_reserve.payment_approved') }}</v-btn>
              </div>
            </td>
            <td v-if="paymentCourse_ext.course.discountprice > 0 && paymentCourse_ext.course.provider_payment != 1">
              <div v-if="paymentAvailable(paymentCourse_ext.payment_state)">
                <v-btn block
                  :disabled="loading_button !== 0"
                  :loading="loading_button === `${paymentCourse_ext.enrollment_courses_id}-${paymentCourse_ext.student_ext.id}`"
                  @click="tcPay('course', paymentCourse_ext.enrollment_courses_id, paymentCourse_ext.course.discountprice, paymentCourse_ext.type_id, paymentCourse_ext.student_ext.id, true)"
                  color="primary">{{ $t('extracurriculares.pay_reserve.cc_payment') }}</v-btn>
              </div>
              <div v-if="paymentPending(paymentCourse_ext.payment_state)">
                <v-btn
                  :loading="payment_loading === paymentCourse_ext.platform_payments_id"
                  :disabled="payment_loading === paymentCourse_ext.platform_payments_id"
                  block
                  @click="verifyPay(paymentCourse_ext.platform_payments_id)"
                  color="accent">{{ $t('extracurriculares.pay_reserve.verify') }}</v-btn>
              </div>
              <div v-if="paymentApproved(paymentCourse_ext.payment_state)">
                <v-btn block @click="paymentProof(paymentCourse_ext.platform_payments_id, paymentCourse_ext.course_name)" color="accent">{{ $t('extracurriculares.pay_reserve.see_payment_proof') }}</v-btn>
              </div>
            </td>
            <td>
              <div v-if="paymentFailed(paymentCourse_ext.payment_state)">
                <v-btn block @click="paymentProof(paymentCourse_ext.platform_payments_id, paymentCourse_ext.course_name)" color="error">{{ $t('extracurriculares.pay_reserve.payment_failed') }}</v-btn>
              </div>
            </td>

          </tr>
        </tbody>
        <tbody>
          <tr v-for="(paymentType, pt) in paymentDataType" :key="`${pt}-${paymentType && paymentType.platform_payments_id}-${paymentType && paymentType.payment_state}`">
            <td align="center">{{paymentType.student.full_name}}</td>
            <td align="center">{{paymentType.type_name}}</td>
            <td align="center">${{formatNumber(paymentType.course_type.discountprice)}}</td>
            <td align="center">{{paymentType.qty}}</td>
            <td align="center">${{formatNumber(paymentType.course_type.discountprice)}}</td>
            <td>
              <v-btn block outline color="info" @click="registerDetails('type', paymentType.type_id, paymentType.student.id)">{{ $t('extracurriculares.pay_reserve.details') }}</v-btn>
            </td>
            <td>
              <v-btn block color="info" @click="openClothesDetail(paymentType.student.id)">{{ $t('extracurriculares.pay_reserve.clothes') }}</v-btn>
            </td>
            <td colspan="2" v-if="paymentType.siesa_receipt == 'PROVIDER'">
              <v-btn block color="primary">{{ $t('extracurriculares.register.available_courses.provider_pay') }}</v-btn>
            </td>
            <td v-if="paymentType.course_type.discountprice > 0 && paymentType.siesa_receipt != 'PROVIDER' && paymentAvailable(paymentType.payment_state) && paymentType.student.family.employee == 1">
              <v-btn
                v-if="1 == 2"
                @click="payrollPay('type', paymentType.enrollment_id, paymentType.course_type.discountprice, paymentType.type_id, paymentType.student.id)"
                block
                color="primary">{{ $t('extracurriculares.pay_reserve.payroll_discount') }}</v-btn>
            </td>
            <td v-if="paymentType.course_type.discountprice > 0 && paymentType.siesa_receipt != 'PROVIDER'">

              <div v-if="paymentPending(paymentType.payment_state)">
                <v-btn block color="info">{{ $t('extracurriculares.pay_reserve.payment_pending') }}</v-btn>
              </div>
              <div v-if="paymentApproved(paymentType.payment_state)">
                <v-btn block color="success">{{ $t('extracurriculares.pay_reserve.payment_approved') }}</v-btn>
              </div>
            </td>
            <td v-if="paymentType.course_type.discountprice > 0 && paymentType.siesa_receipt != 'PROVIDER'">
              <div v-if="paymentAvailable(paymentType.payment_state)">
                <v-btn block
                  :disabled="loading_button !== 0"
                  :loading="loading_button === `${paymentType.enrollment_id}-${paymentType.student.id}`"
                  @click="tcPay('type', paymentType.enrollment_id, paymentType.course_type.discountprice, paymentType.type_id, paymentType.student.id)"
                  color="primary">{{ $t('extracurriculares.pay_reserve.cc_payment') }}</v-btn>
              </div>
              <div v-if="paymentPending(paymentType.payment_state)">
                <v-btn
                  :loading="payment_loading === paymentType.platform_payments_id"
                  :disabled="payment_loading === paymentType.platform_payments_id"
                  block
                  @click="verifyPay(paymentType.platform_payments_id)"
                  color="accent">{{ $t('extracurriculares.pay_reserve.verify') }}</v-btn>
              </div>
              <div v-if="paymentApproved(paymentType.payment_state)">
                <v-btn block @click="paymentProof(paymentType.platform_payments_id, paymentType.type_name)" color="accent">{{ $t('extracurriculares.pay_reserve.see_payment_proof') }}</v-btn>
              </div>
            </td>
            <td>
              <div v-if="paymentFailed(paymentType.payment_state)">
                <v-btn block @click="paymentProof(paymentType.platform_payments_id, paymentType.type_name)" color="error">{{ $t('extracurriculares.pay_reserve.payment_failed') }}</v-btn>
              </div>
            </td>
          </tr>
          <tr v-for="(paymentDataTypeExt, pt) in paymentDataType_ext" :key="`${pt}e-${paymentDataTypeExt && paymentDataTypeExt.platform_payments_id}-${paymentDataTypeExt && paymentDataTypeExt.payment_state}`">
            <td align="center">{{paymentDataTypeExt.student_ext.full_name}}</td>
            <td align="center">{{paymentDataTypeExt.type_name}}</td>
            <td align="center">${{formatNumber(paymentDataTypeExt.course_type.discountprice)}}</td>
            <td align="center">{{paymentDataTypeExt.qty}}</td>
            <td align="center">${{formatNumber(paymentDataTypeExt.course_type.discountprice)}}</td>
            <td>
              <v-btn block outline color="info" @click="registerDetails('type', paymentDataTypeExt.type_id, paymentDataTypeExt.student_ext.id, true)">{{ $t('extracurriculares.pay_reserve.details') }}</v-btn>
            </td>
            <td>
              <v-btn block color="info" @click="openClothesDetail(paymentDataTypeExt.student_ext.id, true)">{{ $t('extracurriculares.pay_reserve.clothes') }}</v-btn>
            </td>
            <td colspan="2" v-if="paymentDataTypeExt.siesa_receipt == 'PROVIDER'">
              <v-btn block color="primary">{{ $t('extracurriculares.register.available_courses.provider_pay') }}</v-btn>
            </td>
            <td v-if="paymentDataTypeExt.course_type.discountprice > 0 && paymentDataTypeExt.siesa_receipt != 'PROVIDER' && paymentAvailable(paymentDataTypeExt.payment_state) && paymentDataTypeExt.family && paymentDataTypeExt.family.employee == 1">
              <v-btn
                v-if="1 == 2"
                @click="payrollPay('type', paymentDataTypeExt.enrollment_id, paymentDataTypeExt.course_type.discountprice, paymentDataTypeExt.type_id, paymentDataTypeExt.student_ext.id, true)"
                block
                color="primary">{{ $t('extracurriculares.pay_reserve.payroll_discount') }}</v-btn>
            </td>
            <td v-if="paymentDataTypeExt.course_type.discountprice > 0 && paymentDataTypeExt.siesa_receipt != 'PROVIDER'">

              <div v-if="paymentPending(paymentDataTypeExt.payment_state)">
                <v-btn block color="info">{{ $t('extracurriculares.pay_reserve.payment_pending') }}</v-btn>
              </div>
              <div v-if="paymentApproved(paymentDataTypeExt.payment_state)">
                <v-btn block color="success">{{ $t('extracurriculares.pay_reserve.payment_approved') }}</v-btn>
              </div>
            </td>
            <td v-if="paymentDataTypeExt.course_type.discountprice > 0 && paymentDataTypeExt.siesa_receipt != 'PROVIDER'">
              <div v-if="paymentAvailable(paymentDataTypeExt.payment_state)">
                <v-btn block
                  :disabled="loading_button !== 0"
                  :loading="loading_button === `${paymentDataTypeExt.enrollment_id}-${paymentDataTypeExt.student_ext.id}`"
                  @click="tcPay('type', paymentDataTypeExt.enrollment_id, paymentDataTypeExt.course_type.discountprice, paymentDataTypeExt.type_id, paymentDataTypeExt.student_ext.id, true)"
                  color="primary">{{ $t('extracurriculares.pay_reserve.cc_payment') }}</v-btn>
              </div>
              <div v-if="paymentPending(paymentDataTypeExt.payment_state)">
                <v-btn
                  :loading="payment_loading === paymentDataTypeExt.platform_payments_id"
                  :disabled="payment_loading === paymentDataTypeExt.platform_payments_id"
                  block
                  @click="verifyPay(paymentDataTypeExt.platform_payments_id)"
                  color="accent">{{ $t('extracurriculares.pay_reserve.verify') }}</v-btn>
              </div>
              <div v-if="paymentApproved(paymentDataTypeExt.payment_state)">
                <v-btn block @click="paymentProof(paymentDataTypeExt.platform_payments_id, paymentDataTypeExt.type_name)" color="accent">{{ $t('extracurriculares.pay_reserve.see_payment_proof') }}</v-btn>
              </div>
            </td>
            <td>
              <div v-if="paymentFailed(paymentDataTypeExt.payment_state)">
                <v-btn block @click="paymentProof(paymentDataTypeExt.platform_payments_id, paymentDataTypeExt.type_name)" color="error">{{ $t('extracurriculares.pay_reserve.payment_failed') }}</v-btn>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </v-layout>
    <v-layout row justify-end>
      <div>
        <v-checkbox
          color="primary"
          v-model="terms_check"
          value="value">
          <template v-slot:label>
            <div>
              {{ $t('extracurriculares.pay_reserve.agree') }}
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <a
                      @click.prevent.stop="showTerms"
                      v-on="on"
                    >
                      {{ $t('extracurriculares.pay_reserve.terms_conditions') }}
                    </a>
                  </template>
                  {{ $t('extracurriculares.pay_reserve.see_terms_conditions') }}
                </v-tooltip>
              </div>
            </template>
          </v-checkbox>
      </div>
    </v-layout>
    <v-layout row wrap justify-center align-center mb-3 mt-2>
      <v-flex xs1>
        <v-img contain :src="`${appUrl}/storage/img/payment/pse-min.jpg`"></v-img>
      </v-flex>
      <v-flex xs1>
        <v-img contain :src="`${appUrl}/storage/img/payment/visa-min.webp`"></v-img>
      </v-flex>
      <v-flex xs1>
        <v-img contain :src="`${appUrl}/storage/img/payment/Mastercard-min.jpg`"></v-img>
      </v-flex>
      <v-flex xs1>
        <v-img contain :src="`${appUrl}/storage/img/payment/diners-min.jpg`"></v-img>
      </v-flex>
    </v-layout>
    <v-dialog
        v-model="payment_dialog"
        width="600"
        persistent
      >
        <v-card>
          <v-card-title
            class="headline primary white--text"
            primary-title
          >
            {{ $t('payments.payment_text_title') }}
          </v-card-title>

          <v-card-text v-html="$t('payments.payment_text')">
          </v-card-text>

        </v-card>
      </v-dialog>
      <v-dialog
        v-model="payment_detail_dialog"
        width="350"
        persistent
      >
      <payment-proof
        :payment="payment_to_show"
        :payment_detail="payment_detail"
      >
      </payment-proof>
      <v-card class="pt-3">
        <v-layout row justify-center align-center>
          <v-btn
            color="primary"
            @click="payment_detail_dialog = false"
          >
            {{ $t('close') }}
          </v-btn>
        </v-layout>
      </v-card>
      </v-dialog>
      <v-dialog
        v-model="register_detail_dialog"
        width="750"
        persistent
      >
      <register-detail
        :detail="register_detail"
      >
      </register-detail>
      <v-card class="pt-3">
        <v-layout row justify-center align-center>
          <v-btn
            color="primary"
            @click="register_detail_dialog = false"
          >
            {{ $t('close') }}
          </v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="transport_modal"
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-layout pa-5 row wrap>
          <v-flex xs6>
            <v-select
              :items="transport_items"
              v-model="transport"
              :label="$t('extracurriculares.pay_reserve.choose_transport')"
              clearable
            ></v-select>
          </v-flex>
          <v-flex class="pl-2" xs4>
            <v-btn @click="saveTransport" color="primary">{{ $t('extracurriculares.pay_reserve.save') }}</v-btn>
          </v-flex>
        </v-layout>
        <v-layout row justify-center align-center>
          <v-btn
            color="primary"
            @click="transport_modal = false"
            flat
          >
            {{ $t('close') }}
          </v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="terms_error_dialog"
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-text>
          <v-layout row justify-center>
            <div>
              {{ $t('extracurriculares.pay_reserve.must_accept_terms_conditions') }}
            </div>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout row justify-center align-center>
            <v-btn
              color="primary"
              @click="terms_error_dialog = false"
              flat
            >
              {{ $t('close') }}
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="terms_dialog"
      max-width="600px"
      transition="dialog-transition"
    >
      <terms
        v-on:closeTerms="terms_dialog = false"
      ></terms>
    </v-dialog>
    <v-dialog
        v-model="course_clothes_dialog"
        width="750"
        persistent
      >
      <course-clothes
        :course_clothes="courses_clothes"
        v-on:refreshClothes="refreshClothes"
      >
      </course-clothes>
      <v-card class="pt-3">
        <v-layout row justify-center align-center>
          <v-btn
            color="primary"
            @click="course_clothes_dialog = false"
          >
            {{ $t('close') }}
          </v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  import paymentProof from './../../payment/proof'
  import registerDetail from './register_detail'
  import terms from './terms'
  import courseClothes from './course_clothes'
  export default {
    name: 'pay-reserve-view',
    components: {
      'payment-proof': paymentProof,
      'register-detail': registerDetail,
      'terms': terms,
      'course-clothes': courseClothes,
    },
    created () {
      this.$store.dispatch('fetchPaymentData');
      this.$store.dispatch('fetchRegisteredCourses')
    },
    data() {
      return {
        terms_check: false,
        terms_error_dialog: false,
        terms_dialog: false,
        appUrl: window.config.appUrl,
        payment_dialog: false,
        loading_button: 0,
        payment_detail_dialog: false,
        payment_to_show: {},
        payment_detail: '',
        register_detail_dialog: false,
        register_detail: [],
        register_detail_type: '',
        register_detail_id: '',
        idPago: '',
        payment_loading: 0,
        register_detail_student_id: '',
        register_detail_external: false,
        validations: 0,
        transport_modal: false,
        transport_items: [
          { value: 'asia', text: 'Asia' },
          { value: 'senderos', text: 'Senderos' },
          { value: 'buseticas', text: 'Buseticas' },
        ],
        transport: '',
        transport_type: '',
        transport_id: '',
        transport_total: '',
        transport_course_type_id: '',
        transport_student_id: '',
        courses_clothes: [],
        course_clothes_dialog: false,
        course_clothes_student: '',
        external_transport: false
      }
    },
    watch: {
      registered_courses(newValue, oldValue) {
        this.fetchDetaildata()
        if (this.$route.query.idPago) {
          const idPago = this.$route.query.idPago
          const payment = this.registered_courses.find(course => {
            if (course.payment) {
              if (course.payment.payment_id == idPago) {
                return course.payment
              }
            }
            return false
          });

          if (payment && payment.payment && payment.payment.payment_state === 'PENDING' && this.validations === 0) {
            this.validations += 1
            this.verifyPay(payment.payment.id)
          }
        }
      },
      paymentDataType(newValue, oldValue) {
        this.fetchDetaildata()
      },
      paymentDataCourse(newValue, oldValue) {
        this.fetchDetaildata()
      },
      course_clothes_dialog(newValue, oldValue) {
        if (oldValue && !newValue) {

          this.$store.dispatch('fetchRegisteredCourses')
          this.course_clothes_student = ''
        }
      }
    },
    computed: {
      ...mapGetters({
        paymentDataType: 'paymentDataType',
        paymentDataCourse: 'paymentDataCourse',
        paymentDataType_ext: 'paymentDataType_ext',
        paymentDataCourse_ext: 'paymentDataCourse_ext',
        student_in_register: 'studentInRegister',
        registered_courses: 'registeredCoursesSaved',
        loading: 'loading',
        locale: 'locale'
      }),
      no_payments_available() {
        return this.paymentDataType.length === 0 && this.paymentDataCourse.length === 0
      }
    },
    methods: {
      psePay(type, id, total, course_type_id, student_id) {
        if (!this.terms_check) {
          this.terms_error_dialog = true
          return
        }
        this.loading_button = `${id}-${student_id}`;
        axios.post('/api/extracurriculares/registration/pay/pse',
          {
            type,
            id,
            total,
            student_id,
            course_type_id
          }
          )
          .then(resp => {
            if (resp.status === 200) {
              this.payment_dialog = true;
              setTimeout(() => {
                // this.payment_dialog = false;
                window.location = resp.data.urlRedirect;
              }, 5000);
            } else {
              this.$store.dispatch('responseMessage', {
                type: 'error',
                text: this.$t('extracurriculares.pay_reserve.payment_error'),
                title: this.$t('error_alert_text'),
                modal: true
              })
            }
            this.loading_button = 0;
          })
          .catch(error => {
            this.loading_button = 0;
          })
      },
      tcPay(type, id, total, course_type_id, student_id, external = false) {
        if (!this.terms_check) {
          this.terms_error_dialog = true
          return
        }
        this.loading_button = `${id}-${student_id}`;
        axios.post(`/api/extracurriculares/registration/pay/ptp`, {
          type,
          id,
          total,
          student_id,
          course_type_id,
          external
        })
          .then(resp => {
            if (resp.status === 200) {
              if (resp.data.error) {
                this.$store.dispatch('responseMessage', {
                  type: 'error',
                  text: resp.data.message,
                  title: this.$t('error_alert_text'),
                  modal: true
                })
                this.loading_button = 0;
                return;
              }
              this.payment_dialog = true;
              setTimeout(() => {
                // this.payment_dialog = false;
                window.location = resp.data.url;
              }, 5000);
            } else {
            }
            this.loading_button = 0;
          })
          .catch(error => {
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: this.$t('extracurriculares.pay_reserve.payment_error'),
              title: this.$t('error_alert_text'),
              modal: true
            })
            this.loading_button = 0;
            console.log(error)
          })
      },
      payrollPay(type, id, total, course_type_id, student_id, external = false) {
        if (!this.terms_check) {
          this.terms_error_dialog = true
          return
        }
        axios.post(`/api/extracurriculares/registration/pay/payroll`, {
          type,
          id,
          total,
          student_id,
          course_type_id,
          external
        })
        .then(resp => {
          if (resp.status === 200) {
            if (!resp.data.payroll_available) {
              this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: this.$t('extracurriculares.pay_reserve.payroll_not_available'),
                title: this.$t('extracurriculares.pay_reserve.payroll_discount'),
                modal: true
              })
            }
            this.$store.dispatch('fetchPaymentData')
            this.$store.dispatch('fetchRegisteredCourses')
          }
        })
        .catch(error => {
          console.log(error)
        })
      },
      paymentFailed(payment_state) {
        return payment_state === 'FAILED' ||
                payment_state === 'NOT_AUTHORIZED' ||
                payment_state === 'REJECTED' ||
                payment_state == '0'
      },
      paymentApproved(payment_state) {
        return payment_state === 'OK' ||
        payment_state === 'APPROVED'
      },
      paymentPending(payment_state) {
        return payment_state === 'PENDING' ||
        payment_state === 'iniciado'
      },
      paymentAvailable(payment_state) {
        if (!payment_state || this.paymentFailed(payment_state)) {
          return true
        }

        return false
      },
      verifyPay(payment_id) {
        this.payment_loading = payment_id
        axios.get(`/api/extracurriculares/registration/pay/verify/${payment_id}`)
          .then(resp => {
            if (resp.status === 200) {
              this.$store.dispatch('fetchPaymentData')
              this.$store.dispatch('fetchRegisteredCourses')
            }
            this.payment_loading = 0
          })
          .catch(error => {
            console.log(error)
            this.payment_loading = 0
          })
      },
      paymentProof(payment_id, course_name) {
        this.payment_detail_dialog = true
        const payment_to_show = this.registered_courses
          .find(register => register.payment_id === payment_id)
          .payment

        this.payment_to_show = payment_to_show
        this.payment_detail = course_name

      },
      registerDetails(type, id, student_id, external = false) {
        console.log(type)
        console.log(id)
        console.log(student_id)
        console.log(external)
        this.register_detail_type = type
        this.register_detail_id = id
        this.register_detail_student_id = student_id
        this.register_detail_external = external
        let courses = []
        if (external) {
          courses = this.registered_courses
            .filter(register => register.user_dependant_id === student_id)
        } else {
          courses = this.registered_courses
            .filter(register => register.student_id === student_id)
        }


        if (!courses || this.register_detail_type == '' || this.register_detail_id == '') {
          this.register_detail_type = ''
          this.register_detail_id = ''
          this.register_detail_dialog = false
          this.register_detail_student_id = false
          return;
        }

        const enrolled_courses =
          courses.filter(enrollment => {
            if (type === 'type') {
              return enrollment.course.course_type_id == id
            } else {
              return enrollment.course.id == id
            }
          })

        if (enrolled_courses.length === 0) {
          this.register_detail_type = ''
          this.register_detail_id = ''
          this.register_detail_dialog = false
          this.register_detail_student_id = false
          return;
        }

        this.register_detail_dialog = true
        this.register_detail = enrolled_courses
        console.log(JSON.stringify(enrolled_courses));
      },
      fetchDetaildata() {
        if (!this.register_detail_dialog) {
          return
        }
        this.registerDetails(this.register_detail_type, this.register_detail_id, this.register_detail_student_id, this.register_detail_external)
      },
      formatNumber(number) {
        if(!number || typeof number === 'undefined') {
            return 0;
        } else {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
      },
      openTransportModal(type, id, total, course_type_id, student_id, enrollment, external = false) {
        this.register_detail_type = ''
        this.register_detail_id = ''
        this.register_detail_student_id = ''
        if (type == 'type') {
          this.transport = enrollment
        } else {
          if (enrollment) {
            this.transport = enrollment.transport
          }
        }
        this.external_transport = external
        this.transport_modal = true
        this.transport_type = type
        this.transport_id = id
        this.transport_total = total
        this.transport_course_type_id = course_type_id
        this.transport_student_id = student_id

      },
      saveTransport() {
        axios.post('/api/extracurriculares/enrollment/transport',
        {
          type: this.transport_type,
          id: this.transport_id,
          total: this.transport_total,
          course_type_id: this.transport_course_type_id,
          student_id: this.transport_student_id,
          transport: this.transport,
          external: this.external_transport
        })
        .then(resp => {
          if (resp.status === 200) {
            this.$store.dispatch('responseMessage', {
              type: 'success',
              text: this.$t('extracurriculares.pay_reserve.transport_saved'),
              modal: false
            })
            this.transport_modal = false
            this.$store.dispatch('fetchPaymentData')
            this.$store.dispatch('fetchRegisteredCourses')
          }
        })
        .catch(error => {

        })
      },
      showTerms() {
        this.terms_dialog = true
      },
      openClothesDetail(student_id, external = false) {
        let courses = []
        if (external) {
          courses = this.registered_courses
            .filter(register => register.user_dependant_id === student_id)
        } else {
          courses = this.registered_courses
            .filter(register => register.student_id === student_id)
        }
          this.course_clothes_student = student_id
          this.courses_clothes = courses
          this.course_clothes_dialog = true
      },
      refreshClothes() {
        this.$store.dispatch('fetchRegisteredCourses')
          .then(() => {
            console.log('done')
            const courses = this.registered_courses
            .filter(register => register.student_id === this.course_clothes_student)
            this.courses_clothes = courses
          })

      }
    },
  }
</script>

<style>
  table, td, th {
    padding: 10px 5px;
  }

  table {
    border: 1px solid lightgray;
    width: 100%;
  }

  tr:nth-child(even) {
    background: rgb(233, 233, 233);
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/enrollment/pay_reserve.vue